import { AnalyticsTypes } from '../../middleware/google-analytics';

export const ActionTypes = {
    TRACK_PREVIOUS_MONOLITH_ACTION: '@@crossPageActions/TRACK_PREVIOUS_MONOLITH_ACTION',
    TRACK_THEMED_SEARCH_CLICK: '@@crossPageActions/tracking/TRACK_THEMED_SEARCH_CLICK',
};

export const trackPreviousMonolithAction = ({
    action,
    category,
    label,
    pageId,
}) => ({
    type: ActionTypes.TRACK_PREVIOUS_MONOLITH_ACTION,
    meta: {
        analytics: {
            action,
            type: AnalyticsTypes.TrackPreviousMonolithEvent,
            category,
            label,
            pageId,
        },
    },
});
